export var headerPortalTokens = {
  defaultVariant: "h2",
  fontWeight: 700,
  variants: {
    h0: {
      fontVariant: {
        desktop: "xxxl",
        notDesktop: "xxl"
      },
      pt: 20,
      pb: 12
    },
    h1: {
      fontVariant: {
        desktop: "xxl",
        notDesktop: "xl"
      },
      pt: 32,
      pb: 20
    },
    h2: {
      fontVariant: {
        desktop: "xl",
        notDesktop: "l"
      },
      pt: {
        desktop: 36,
        notDesktop: 38
      },
      pb: 18
    },
    h3: {
      fontVariant: {
        desktop: "l",
        notDesktop: "m"
      },
      pt: {
        desktop: 16,
        notDesktop: 24
      },
      pb: {
        desktop: 6,
        notDesktop: 8
      }
    },
    h4: {
      fontVariant: {
        desktop: "m",
        notDesktop: "s"
      },
      pt: {
        desktop: 12,
        notDesktop: 24
      },
      pb: {
        desktop: 8,
        notDesktop: 8
      }
    },
    h5: {
      fontVariant: "s",
      pt: {
        desktop: 8,
        notDesktop: 24
      },
      pb: {
        desktop: 6,
        notDesktop: 8
      }
    }
  }
};